import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';

import { TranslationKeyMap } from '../task/task.component.i18n';

@Component({
    selector: 'cmps-task-list-task-title',
    templateUrl: './task-title.component.html',
    host: {
        class: 'cmps-cdk-font-size-14p cmps-cdk-pos-relative',
    },
})
export class TaskTitleComponent implements OnDestroy {
    @Input() completed: boolean;
    @Input() editing: boolean;
    @Input() title: string;
    @Input() msftTaskId: string;
    @Input() placeholder: string;
    @Output() click: EventEmitter<void>;
    @Output() enter: EventEmitter<void>;

    nextTitle: string | null;

    /** @private */
    _i18n = TranslationKeyMap;

    /** @private */
    _document = document;

    constructor() {
        this.click = new EventEmitter();
        this.enter = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.click.complete();
        this.enter.complete();
    }
}
